<template>
    <div class="prepareCoursesNoteDowload margin-top">
        <div class="container">
            <div  class="eCard eCardBordered">
                <div class="eCard-body">
                    <p class="card-title">
                        下载记录
                    </p>
                    <div class="no-outline mr-left ant-radio-group ant-radio-group-outline ant-radio-group-default" v-show="timeRange.length>0">
                        <el-button size="small" :type="item.timeScope===selectTimeScore?'primary':''"
                                   @click="selectTapTimeScore(item.timeScope)"
                                   v-for="item in timeRange" :key="item.text">
                             <span>
                                {{item.text}}
                            </span>
                        </el-button>
                     </div>
                     <loading v-show="timeRange.length<1" :show="loadingTime"></loading>
                </div>
            </div>
            <div class="margin-top eCard eCardBordered">
                <div class="eCard-body">
                    <div  class="mr-top ant-table-wrapper">
                        <div class="ant-spin-nested-loading">
                            <div class="ant-spin-container">
                                <div class="ant-table ant-table-scroll-position-left ant-table-default">
                                    <div class="ant-table-content">
                                        <div class="ant-table-body">
                                           <common-table
                                                   @handlerPage="handlerPage"
                                                   :tableData="tableData"
                                                   :headerCellStyle="headerCellStyle"
                                                   :loading="loadingContentTable"
                                                   :pageObj="pageObj"
                                                   :fieldList="fieldList">
                                           </common-table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {downloadRecordTimeRange, dTimeSearchLogList} from "../../config";

    export default {
        name: "prepareCoursesNoteDowload",
        data(){
          return{
              //设置默认选中时间范围
              selectTimeScore:'',
              timeRange:[],
              loadingTime:true,
              loadingContentTable:true,
              pageObj:{
                  size:10,
                  total:0,
                  currentPage:1,
                  func:'func'
              },
              fieldList:[
                  {label:'课件类型',prop:'typeName'},
                  {label:'课件名称',prop:'name'},
                  {label:'创建时间',prop:'createdAt'}
              ],
              headerCellStyle:{
                  background: 'rgba(0,0,0,0.02)',
                  textAlign: 'center',
                  fontWeight:'bolder'
              },
              tableData:[]
          }
        },
        mounted(){
            this.defaultLoadTimeFw();
        },
        methods:{
            //触发切换时间范围
            selectTapTimeScore(val){
                this.selectTimeScore=val;
                this.pageObj.currentPage=1;
                this.searchDowloadList();
            },
            //触发分页的方法
            handlerPage(val){
                this.pageObj.currentPage=val;
                this.searchDowloadList();
            },
            //默认查出下载记录 时间范围
            async defaultLoadTimeFw(){
                let result=await downloadRecordTimeRange();
                this.loadingTime=true;
                if(result.status){
                    this.loadingTime=false;
                    this.timeRange=result.data;
                    this.searchDowloadList();
                }else{
                    this.loadingTime=false;
                }
            },
            //根据时间范围查询下载记录列表
            async searchDowloadList(){
                let result=await dTimeSearchLogList(this.selectTimeScore,this.pageObj.currentPage,10);
                this.loadingContentTable=true;
                if(result.status){
                    this.loadingContentTable=false;
                    this.tableData=result.data.data;
                    this.pageObj.total=result.data.totalRecords;
                }else{
                    this.loadingContentTable=false;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
 #prepareCoursesNoteDowload{
     background: #f1f5f8;
     height:100%;
     padding: 20px 0;
     .container{
         margin: 0 auto;
         width:1200px;
         min-width:1280px;
         .eCard{
             -webkit-box-sizing: border-box;
             box-sizing: border-box;
             margin: 0;
             padding: 0;
             color: rgba(0,0,0,.65);
             font:{
                 variant: tabular-nums;
                 feature-settings: "tnum";
             }
             line-height: 1.5;
             list-style: none;
             -webkit-font-feature-settings: "tnum";
             /*font-feature-settings: "tnum";*/
             position: relative;
             background: #fff;
             border-radius: 2px;
             -webkit-transition: all .3s;
             transition: all .3s;
             .eCard-body {
                 padding: 20px;
                 zoom: 1;
                 .card-title{
                     display: -webkit-box;
                     display: -ms-flexbox;
                     display: flex;
                     -webkit-box-align: center;
                     -ms-flex-align: center;
                     align-items: center;
                     font-size: 16px;
                     color: #333;
                     position: relative;
                     margin-bottom: 1em;
                      &:before {
                         content: "";
                         width: 4px;
                         height: 16px;
                         background: #0a93fc;
                         margin-right: 20px;
                     }
                 }

                 .ant-radio-group {
                     -webkit-box-sizing: border-box;
                     box-sizing: border-box;
                     margin-left: 20px!important;
                     color: rgba(0,0,0,.65);
                     font-size: 14px;
                     font-variant: tabular-nums;
                     line-height: 1.5;
                     list-style: none;
                     -webkit-font-feature-settings: "tnum";
                     font-feature-settings: "tnum";
                     display: inline-block;
                 }
             }

         }
         .eCardBordered{
             border: 0 solid #e8e8e8 {
                 radius: 4px;
             }
             -webkit-box-shadow: 0 0 6px 0 rgb(73 83 98 / 12%);
             box-shadow: 0 0 6px 0 rgb(73 83 98 / 12%);
         }
     }
 }
</style>
